import React from "react"
import { Col, Row, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch } from "react-redux"
import FormLabel from "../../../shared/formLabel"

function FormTextbox(props) {
  const {
    textDesc,
    form,
    field,
    maxLength,
    coverageCategory,
    coverageCode,
    formName,
    clickedNext,
    toUpperCase,
    disabled,
  } = props

  const dispatch = useDispatch()
  const errorsMsg = getIn(form.errors, field.name)
  // const isValid = formIsValid

  //const touched = getIn(form.touched, field.name)
  const handleTextChange = (event, error, category, coverageCode) => {
    // console.log(form)
    // console.log(field)

    const inputName = event.target.name
    const inputValue = event.target.value

    dispatch(
      updateCategoryClaimData(category, coverageCode, inputName, inputValue)
    )

    form.resetForm()
    form.validateForm().then(errors => {
      if (Object.entries(errors).length === 0) {
        dispatch(formIsValidUpdate(formName, true))
      } else {
        dispatch(formIsValidUpdate(formName, false))
      }
    })
  }

  const inputErrorClassName = (touched, errors, inputName) => {
    // return (clickedNext && errors[inputName]) ||
    //   (errors[inputName] && touched[inputName])
    //   ? "is-invalid"
    //   : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    return (clickedNext && errors[inputName]) ||
      (errors[inputName] && touched[inputName]) ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Field
            name={field.name}
            className={
              "inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name) +
              (disabled ? " disableBGcolor" : "")
            }
            type="text"
            onChange={event => {
              form.handleChange(event)
            }}
            onBlur={event => {
              form.handleBlur(event)
              field.onBlur(event)
              handleTextChange(
                event,
                form.errors,
                coverageCategory,
                coverageCode
              )
            }}
            maxLength={maxLength}
            autoComplete="new-password"
            value={
              toUpperCase
                ? field.value.toUpperCase()
                : field.value
                ? field.value
                : ""
            }
            readOnly={disabled ? "readOnly" : ""}
          />
          {/* {errors && touched && (
            <span className="InputError">{errorMsg}</span>
          )} */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormTextbox
